import React, { useState, useCallback, useMemo } from 'react';
import cn from 'classnames';
import { useNavigate } from 'react-router-dom';
import { TouchableButton } from '@components/common/Touchable/index';
import { flowType } from '@utility/userInfo';
import { LABEL } from '@veriables';
import { ReactComponent as ProfileIcon } from '@assets/images/profile_icon.svg';
import GuestInformationRevamp from '../../../../CallCenter/GuestInformationRevamp';
import { safeJsonParse } from '@utility/helperFunction';
import styles from './CallCenterContentHeader.module.scss';
import { findCountryCode } from '@utility/countryCode';
import FullWithModal from '@components/common/Modal/FullWidthModal';



const CallCenterContentHeader = ({ seat = {}, serverAppTheme = {} }) => {
  const navigate = useNavigate();
  const flowTypeValue = useMemo(() => flowType(), []);
  const [editCallCenterModal, setEditCallCenterModal] = useState(false);
  const checkInfo = useMemo(() => safeJsonParse(
    window.sessionStorage.getItem('callCenterUserInfo'),
    {}
  ), [editCallCenterModal]);



  const orderIdStyle = useMemo(() => ({
    color: serverAppTheme?.primary_text || '#111',
    whiteSpace: 'nowrap',
    fontWeight: 600,
  }), [serverAppTheme?.primary_text]);
  const codeToShow = () => {
    const { code, dialCode, name } = findCountryCode(checkInfo?.countryCode || '1');
    return `${code} (+${dialCode})`;
  };



  return (
    <div
          style={{ height: '40px' }}
          className="row w-95 d-flex p-0 m-0 align-items-start fs-16 fw-600"
        >
          <div
            className={cn(
              'w-25 mr-2 d-flex justify-content-between align-items-center py-1',
              styles.inputBox
            )}
            onClick={() => setEditCallCenterModal(true)}
          >
            <div className="w-20 d-flex justify-content-center">
              <ProfileIcon
                height="100%"
                width="100%"
                className="pr-1"
                fill={serverAppTheme.iconcolor}
              />
            </div>
            <div className="w-80 p-0 m-0 overflowXHidden text-truncate d-flex align-items-center">
              {checkInfo?.name.length > 10 ? `${checkInfo?.name.slice(0,10)}...` : checkInfo?.name} 
            </div>
          </div>
          <div
            className={cn(
              'w-45 mr-2 position-relative d-flex justify-content-center align-items-center py-1',
              styles.inputBox
            )}
            onClick={() => setEditCallCenterModal(true)}
          >
            <div className="mr-1">{codeToShow()}</div>
            <div className="w-60 text-truncate p-0">{checkInfo?.phoneNumber}</div>
          </div>
          <div
            className={cn('w-25 text-truncate py-1', styles.inputBox)}
            onClick={() => setEditCallCenterModal(true)}
          >
            {checkInfo?.pickupTime?.[0]}
          </div>
      {editCallCenterModal && (
        <FullWithModal
          isOpen={editCallCenterModal}
          isModalCenter
          editCallCenter={true}
          customClass2={cn("w-100 h-100")}
          noBackground
          style={{ fontFamily: 'Poppins', position: 'relative', display: 'flex', flexDirection: 'column', width: '100%', pointerEvents: 'auto', backgroundColor: serverAppTheme.popUp_bg, backgroundClip: 'padding-box', height: '100%' }}
          className={cn('h-100')}
        >
          <div className="h-100 justify-content-center align-items-center text-center">
            <GuestInformationRevamp editCallCenter={true} setEditCallCenterModal={setEditCallCenterModal} editCallCenterModal={editCallCenterModal} seat={seat} serverAppTheme={serverAppTheme} navigate={navigate} />
          </div>
        </FullWithModal>
      )}

    </div>
  );
};



const MemoizedHeader = React.memo(CallCenterContentHeader);

export default MemoizedHeader;
